import { render, staticRenderFns } from "./CertificateConfig.vue?vue&type=template&id=9ae9f054&scoped=true&"
import script from "./CertificateConfig.vue?vue&type=script&lang=js&"
export * from "./CertificateConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae9f054",
  null
  
)

export default component.exports